export default __webpack_public_path__ + "static/media/green_logo.a7140791.png";